import axios from "axios";
import {nodeUtils} from "../utils";
import {CLOUDINARY_ID} from "../constants";

export const listNodes = (cursor, limit, success, failure) => {
    let url = "/api/v1/node/list?limit=" + limit;

    if (cursor) {
        url += "&cursor=" + cursor;
    }

    axios.get(url)
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const createNode = (node, success, failure) => {
    const url = `/api/v1/node/`;

    axios.post(url, {
        imageUrl: node.imageUrl,
        firstName: node.firstName,
        lastName: node.lastName,
        phones: nodeUtils.sanitizeLabeledStrings(node.phones),
        emails: nodeUtils.sanitizeLabeledStrings(node.emails),
        urls: nodeUtils.sanitizeLabeledStrings(node.urls),
        addresses: nodeUtils.sanitizeLabeledAddresses(node.addresses),
        dates: nodeUtils.sanitizeLabeledDates(node.dates),
        others: nodeUtils.sanitizeLabeledStrings(node.others),
        tags: node.tags,
        metadata: node.metadata,
    })
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const updateNode = (nodeId, node, success, failure) => {
    const url = `/api/v1/node/${nodeId}/`;

    axios.put(url, {
        imageUrl: node.imageUrl,
        firstName: node.firstName,
        lastName: node.lastName,
        phones: nodeUtils.sanitizeLabeledStrings(node.phones),
        emails: nodeUtils.sanitizeLabeledStrings(node.emails),
        urls: nodeUtils.sanitizeLabeledStrings(node.urls),
        addresses: nodeUtils.sanitizeLabeledAddresses(node.addresses),
        dates: nodeUtils.sanitizeLabeledDates(node.dates),
        others: nodeUtils.sanitizeLabeledStrings(node.others),
        tags: node.tags,
        metadata: node.metadata,
    })
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const deleteNode = (nodeId, success, failure) => {
    const url = `/api/v1/node/${nodeId}/`;

    axios.delete(url)
        .then(response => {
            success(nodeId);
        })
        .catch(err => {
            failure(err);
        });
};

export const uploadImage = (nodeId, image, success, failure) => {
    const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY_ID}/upload`;

    const data = new FormData();
    data.append("upload_preset", "node_image");
    data.append("file", image);
    data.append("tags", nodeId);

    // need to skip the request interceptors (don't want to include the JWT)
    const instance = axios.create();

    instance.post(url, data, {
        headers: {
            "X-Requested-With": "XMLHttpRequest",
        },
    })
    .then(response => {
        const json = response.data;

        success(json.secure_url);
    })
    .catch(err => {
        failure(err);
    });
};
